import { Helper } from '../../Helper';
export class GetObjectHelperBase extends Helper {
    emit(sb, node, options) {
        if (!options.pushValue) {
            sb.emitOp(node, 'DROP');
            return;
        }
        sb.emitHelper(node, options, sb.helpers.getObject);
        sb.emitPushInt(node, this.index);
        sb.emitOp(node, 'PICKITEM');
    }
}

//# sourceMappingURL=GetObjectHelperBase.js.map
